import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { Spacer } from "../spacer";
import { OfferingDetailsDayPassWithCapacity } from "../template_offering_details_daypass_with_capacity";
import { Text } from "../text";
import { partnerConfig } from "./nomadworks_partner_config";
import { useNomadworksAnalytics } from "./nomadworks_analytics";
import { testimonials } from "./nomadworks_data";

const Theme = lazyWithRetry(() => import("./nomadworks_theme"));

const faqs = [
  {
    question: "Can I change the date of my day office booking?",
    answer:
      "Yes. Please either call us or reply to the confirmation email and we will take care of it.",
  },

  {
    question: "Can I share my day office booking with other people?",
    answer:
      "Yes, the day office booking is for you and your team. Please use the invite during confirmation to let us know who the other attendees are.",
  },

  {
    question: "Can I cancel my day office purchase?",
    answer: "Unfortunately, the Day Office is non-refundable.",
  },

  {
    question: "Can I use the meeting rooms?",
    answer:
      "Yes, you can book meeting rooms on an hourly basis. The meeting rooms are charged at an hourly rate. Please contact the front desk for availability and pricing options.",
  },

  {
    question: "Can I use the printer?",
    answer:
      "If you have something urgent that needs printing, please approach the front desk and we will assist you.",
  },

  {
    question:
      "Can I meet with clients or bring a guest into the Nomadworks lounges and common area?",
    answer: "Your Day Office booking is for you and your attendees only.",
  },

  {
    question: "Where can I keep and heat my lunch?",
    answer:
      "There are kitchens, refrigerators and microwaves on each floor to both keep and heat your food. So feel free to bring any snacks or meals with you.",
  },

  {
    question: "Do you offer coffee, tea, or water?",
    answer:
      "We offer a full kitchen and a coffee bar on each floor, including a comprehensive selection of delicious coffee and teas with filtered and spa water.",
  },
];

export function OfferingNomadworksDayOffice() {
  useNomadworksAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsDayPassWithCapacity
        showAddress={false}
        showDirections={false}
        partnerConfig={partnerConfig}
        data={{
          description: (
            <Fragment>
              <Text>
                Enjoy a day or two with your team at a private office for the
                day. Our day office grants you full access to our amenities from
                phone booths to delicious fresh-roasted coffee and herbal teas,
                plus our stunning Manhattan views!
              </Text>
              <Spacer size={8} />
              <Text>
                Enjoy full access during our hours of operation from 8:00 AM - 6
                PM M-F. Open on Saturdays 9 AM - 4 PM.
              </Text>
            </Fragment>
          ),
          amenitiesDescription:
            "Enjoy the community events for the day. Bagels on Monday mornings, Yoga on Tuesdays, and Happy Hour beers/drinks on Thursdays.",
          faqs,
          testimonials,
          generalInfo: {
            title: `Health & safety`,
            description: `We're working hard and have taken extra steps to ensure all our members and their guests are safe and socially distanced at work.`,
            bulletPoints: [
              { text: "Increased cleaning" },
              { text: "Masks provided if you need one." },
              { text: "New tech air filteration system." },
              {
                text: "Dedicated entrance & exit staircases for social distancing.",
              },
            ],
          },
        }}
      />
    </Fragment>
  );
}
